<mat-dialog-actions cdkDrag cdkDragHandle cdkDragRootElement=".cdk-overlay-pane">
	<div class="title"  >
        <span [ngSwitch]="formMode">
            <span *ngSwitchCase="'Create'">
                {{ 'MODALS.HEADERS.CREATE_STATUS' | translate }}
            </span>
            <span *ngSwitchCase="'Edit'">
                {{ 'MODALS.HEADERS.EDIT_STATUS' | translate }}
            </span>
            <span *ngSwitchCase="'View'">
                {{ 'MODALS.HEADERS.VIEW_STATUS' | translate }}
            </span>
        </span>
		<app-component-loading [size]="'inline'" [margin]="'0px'" *ngIf="this.formState === 'Submitting'"></app-component-loading>
	</div>
	<mat-icon svgIcon="close-line" mat-dialog-close style="width: 20px;"></mat-icon>
</mat-dialog-actions>
<form [formGroup]="createNodeForm" class="node-form">
        <fieldset [disabled]="formState ==='Submitting' || formMode === 'View'">
		<mat-form-field class="form-field-cs"  [hideRequiredMarker]="true" style="width: 100% !important;">
			<mat-label>{{ 'MODALS.FIELDS.TITLE' | translate }}</mat-label>
			<input matInput [formControl]="label" autocomplete="disabled" >
			@if (label.hasError('required')) {
			<mat-error>{{'VALIDATION.REQUIRED' | translate}}</mat-error>
			}
		</mat-form-field>
		<mat-form-field class="form-field-cs"  [hideRequiredMarker]="true" style="width: 100% !important; height: unset !important;">
			<mat-label>{{ 'MODALS.FIELDS.DESCRIPTION' | translate }}</mat-label>
			<textarea matInput [formControl]="description" autocomplete="disabled" rows="3" ></textarea>
		</mat-form-field>

		<div class="node-form-row">
			<mat-form-field class="form-field-cs"  [hideRequiredMarker]="true" style="width: 100% !important;">
			<div style="display: flex; flex-direction: row;" *ngIf="colorCode?.value">
				<app-color-picker style="width: 100%;"
						[color]="colorCode?.value"
						[name]="label.value"
						[formControlData]="colorCode"
                        [disabled]="formMode==='View'"
				></app-color-picker>
				<input matInput [formControl]="colorCode" autocomplete="disabled"  style="width: 1px; height: 1px;">
			</div>
			</mat-form-field>
			<app-icon-picker [formControlData]="svg" > </app-icon-picker>
		</div>

		<div class="node-form-checkboxes">
			<mat-checkbox  *ngIf="isSuccessfulShown()===true" formControlName="is_successful"  class="size-xxs text-primary" [disableRipple]="true"  style="width: 100%;" >
                {{ 'MODALS.FIELDS.SUCCESSFUL_STATUS' | translate }}
                <mat-icon    svgIcon="information-line"style="width: 20px; margin-left:8px" [matTooltip]="'MODALS.FIELDS.SUCCESSFUL_STATUS_TOOLTIP' | translate " >  </mat-icon>
			</mat-checkbox>
            <mat-checkbox  *ngIf="isUniversalShown()===true" formControlName="is_universal" class="size-xxs text-primary" disableRipple >
                {{ 'MODALS.FIELDS.UNIVERSAL_STATUS' | translate }}
                <mat-icon svgIcon="information-line"style="width: 20px; margin-left:8px" [matTooltip]="'MODALS.FIELDS.UNIVERSAL_STATUS_TOOLTIP' | translate " > </mat-icon>
			</mat-checkbox>
			<mat-checkbox *ngIf="isToArchiveShown()===true"  formControlName="to_archive" class="size-xxs text-primary"  disableRipple >
				{{'MODALS.FIELDS.TO_ARCHIVE_STATUS' | translate }}
				<mat-icon svgIcon="information-line"style="width: 20px; margin-left:8px" [matTooltip]="'MODALS.FIELDS.TO_ARCHIVE_STATUS_TOOLTIP' | translate " ></mat-icon>
			</mat-checkbox>
			<mat-checkbox *ngIf="is_archive.value === true" formControlName="is_archive" class="size-xxs text-primary"  disableRipple >
				{{'MODALS.FIELDS.IS_ARCHIVE_STATUS' | translate }}
			</mat-checkbox>
		</div>

        <div class="node-form-members" *ngIf="['Edit','View'].includes(formMode) && this.membersInTask">
            <div class="heading-xs text-primary">{{ 'Участники статуса' | translate }}</div>
            
            <div class="node-form-members-avatars" (click)="showDetailedMembers=!showDetailedMembers">
                <app-avatar-panel *ngIf="membersInTask.length>0" [users]="membersInTask"></app-avatar-panel>
                <div class="node-form-members-avatars-btn">
                    <mat-icon  class="base-icon" style="width: 18px;" [svgIcon]="showDetailedMembers?  'arrow-up-s-line' : 'arrow-down-s-line'"></mat-icon> 
                    <button (click)="openAddMemberToStatusForm($event)" data-action="openAddMemberToStatusForm"
                        class="button-icon size-s primary-button node-form-edges-add_button">
                        <mat-icon svgIcon="add-fill"></mat-icon>
                        {{ 'MODALS.BUTTONS.ADD' | translate }}
                    </button>
                </div>
            </div>
            <app-avatar-list *ngIf="showDetailedMembers" style="margin-top: 10px;" 
                [users]="membersInTask" 
                (eventUserDelete)="removeMemberFromStatus($event)" data-action="removeMemberFromStatus">
            </app-avatar-list>
        </div>

		<div class="node-form-edges" *ngIf="isAddEdgeShown() === true">
			<div class="node-form-edges-block" formArrayName="source_ids">
			<div class="heading-xs text-primary" >{{ 'MODALS.FIELDS.INCOMING_STATUSES' | translate }}</div>
			@for (status of statusIn.controls;  track status) {
				<div class="node-form-edges-item body-s-regular text-extra">
				<mat-select class="node-form-edges-item-select body-s-regular text-extra select-rotate" #select 
							disableRipple panelClass="nd-select-status-in-out" 	
							[placeholder]="'BUTTON_TEXT.SELECT' | translate " [formControlName]="$index"	>
					@for (statusSelect of  this.availableStatuses.in;  track statusSelect) {
		<!--            <mat-option  *ngIf="statusIn.value.includes(statusSelect.id) === false || statusSelect.id === status.value" // Не получается использовать из за disabled на поле  --> 
					<mat-option  
							*ngIf="isStatusUsed(statusIn,statusSelect.id) === false || statusSelect.id === status.value"  
							(click)="addEdge(status.value,'In')"
							class="body-s-regular node-form-edges-item-select-option"
							[value]="statusSelect.id"  >
					<div>{{statusSelect?.label}}</div> 
					</mat-option>
					}
				</mat-select>
				<mat-icon svgIcon="close-line" style="width: 16px; cursor: pointer;" 
						(click)="deleteEdge(statusIn,$index,status.value,'In')" data-action="deleteEdge">
				</mat-icon>
				</div>
			}
			<button (click)="addEmptyEdge('In')" data-action="addEmptyEdge"
				class="button-icon size-xs primary-button node-form-edges-add_button">
				<mat-icon svgIcon="add-fill"></mat-icon>
				{{ 'MODALS.BUTTONS.ADD'|translate }}
			</button>
			</div>

			<div class="node-form-edges-block" formArrayName="target_ids">
			<div class="heading-xs text-primary">{{ 'MODALS.FIELDS.OUTCOMING_STATUSES' | translate }}</div>
			@for (status of statusOut.controls;  track status) {
				<div class="node-form-edges-item body-s-regular text-extra">
				<mat-select class="node-form-edges-item-select body-s-regular text-extra select-rotate" 
						disableRipple panelClass="nd-select-status-in-out" 	
						[placeholder]="'BUTTON_TEXT.SELECT' | translate " [formControlName]="$index"	>
					@for (statusSelect of  this.availableStatuses.out;  track statusSelect) {
					<!-- *ngIf="statusOut.value.includes(statusSelect.id) === false || statusSelect.id === status.value"  // Не получается использовать из за disabled на поле  -->
					<mat-option  
						*ngIf="isStatusUsed(statusOut,statusSelect.id) === false || statusSelect.id === status.value"  
						(click)="addEdge(status.value,'Out')"
						class="body-s-regular node-form-edges-item-select-option" 
						[value]="statusSelect.id"  >
						<div>{{ statusSelect?.label }}</div> 
					</mat-option>
					}
				</mat-select>
				<mat-icon svgIcon="close-line" style="width: 16px; cursor: pointer;" 
						(click)="deleteEdge(statusOut,$index,status.value,'Out')" data-action="deleteEdge">
				</mat-icon>
				</div>
			}
			<button (click)="addEmptyEdge('Out')" data-action="addEmptyEdge"
				class="button-icon size-xs primary-button node-form-edges-add_button">
				<mat-icon svgIcon="add-fill"></mat-icon>
				{{ 'MODALS.BUTTONS.ADD'|translate }}
			</button>
			</div>
		</div>

        <div class="universal-info" *ngIf="this.isUniversalInit !== is_universal.value && formMode === 'Edit'">
            {{ 'MODALS.TEXT.SAVE_STATUS_CHANGES' | translate }}
        </div>

		<div class="node-form-button-block" *ngIf="formMode!=='View'">
			<button mat-dialog-close class="button-icon size-xl secondary-button"  [disabled]="this.formState === 'Submitting'">
				<mat-icon svgIcon="close-line"></mat-icon>
				{{ 'MODALS.BUTTONS.CANCEL'|translate }}
			</button>
			<button (click)="formMode === 'Create'? createNewStatus() : updatStatus()"  data-action="createNewStatus updatStatus" 
				[disabled]="createNodeForm.valid !==true || this.formState === 'Submitting'" 	class="button-icon size-xl primary-button">
				<mat-icon svgIcon="save-2-fill"></mat-icon> 
                    {{('MODALS.BUTTONS.SAVE'|translate)}}
			</button>
		</div>
        
    </fieldset>
        <div class="node-form-button-block" style="justify-content: unset;" *ngIf="formMode==='View'">
            <button mat-dialog-close class="button-icon size-xl secondary-button" >
                <mat-icon svgIcon="close-line"></mat-icon>
                {{ 'MODALS.BUTTONS.CLOSE'|translate }}
            </button>
        </div>
	</form>